import React from 'react';
import { ImageFile } from '~/data/types/images';

const shareBtnIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
    >
      <path
        d="M14.2397 12.9673C13.4226 12.9673 12.6864 13.323 12.1755 13.8887L7.57963 11.0201C7.70233 10.7035 7.77038 10.3597 7.77038 10C7.77038 9.64018 7.70233 9.29636 7.57963 8.97994L12.1755 6.1112C12.6864 6.6769 13.4226 7.03265 14.2397 7.03265C15.779 7.03265 17.0312 5.77066 17.0312 4.21939C17.0312 2.66812 15.779 1.40625 14.2397 1.40625C12.7005 1.40625 11.4482 2.66825 11.4482 4.21952C11.4482 4.57921 11.5164 4.92303 11.639 5.23958L7.04329 8.10818C6.53233 7.54249 5.79613 7.18673 4.97901 7.18673C3.43974 7.18673 2.1875 8.44886 2.1875 10C2.1875 11.5513 3.43974 12.8133 4.97901 12.8133C5.79613 12.8133 6.53233 12.4576 7.04329 11.8918L11.639 14.7604C11.5164 15.077 11.4482 15.4208 11.4482 15.7806C11.4482 17.3318 12.7005 18.5938 14.2397 18.5938C15.779 18.5938 17.0312 17.3318 17.0312 15.7806C17.0312 14.2293 15.779 12.9673 14.2397 12.9673ZM12.4661 4.21952C12.4661 3.23394 13.2618 2.43208 14.2397 2.43208C15.2177 2.43208 16.0134 3.23394 16.0134 4.21952C16.0134 5.20509 15.2177 6.00695 14.2397 6.00695C13.2618 6.00695 12.4661 5.20509 12.4661 4.21952ZM4.97901 11.7874C4.00092 11.7874 3.20527 10.9856 3.20527 10C3.20527 9.01443 4.00092 8.21256 4.97901 8.21256C5.95696 8.21256 6.75249 9.01443 6.75249 10C6.75249 10.9856 5.95696 11.7874 4.97901 11.7874ZM12.4661 15.7805C12.4661 14.7949 13.2618 13.993 14.2397 13.993C15.2177 13.993 16.0134 14.7949 16.0134 15.7805C16.0134 16.7661 15.2177 17.5679 14.2397 17.5679C13.2618 17.5679 12.4661 16.7661 12.4661 15.7805Z"
        fill="black"
      />
    </Component>
  );
};

export default shareBtnIcon;
